<template>
  <div id="app">
    <v-app>
      <v-navigation-drawer
        v-model="drawer"
        app
        clipped
      >
        <v-list dense>
          <v-list-item link to="/">
            <v-list-item-action>
              <v-icon>mdi-home</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Hem</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/movies">
            <v-list-item-action>
            <v-icon>mdi-filmstrip</v-icon>
            </v-list-item-action>
            <v-list-item-content>
            <v-list-item-title>Filmer</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/movies/create" v-if="$store.state.isUserLoggedIn">
            <v-list-item-action>
            <v-icon>mdi-eye-plus</v-icon>
            </v-list-item-action>
            <v-list-item-content>
            <v-list-item-title>Ny film</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/login" v-if="!$store.state.isUserLoggedIn">
            <v-list-item-action>
            <v-icon>mdi-login</v-icon>
            </v-list-item-action>
            <v-list-item-content>
            <v-list-item-title>Logga in</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
          <v-list-item @click="logout" v-if="$store.state.isUserLoggedIn">
            <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-content>
            <v-list-item-title>Logga ut</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item link to="/register">
            <v-list-item-action>
            <v-icon>mdi-account-plus</v-icon>
            </v-list-item-action>
            <v-list-item-content>
            <v-list-item-title>Registrera</v-list-item-title>
          </v-list-item-content>
          </v-list-item> -->
        </v-list>
      </v-navigation-drawer>

      <v-app-bar app clipped-left>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title class="mr-4">
          Filmklubben
        </v-toolbar-title>
      </v-app-bar>

      <v-main>
        <v-container class="fill-height" fluid>
          <v-row
            align="center"
            justify="center"
          >
          <v-col>
            <router-view/>
          </v-col>
          </v-row>
        </v-container>
      </v-main>
    <v-footer app>
      <span>&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    this.$vuetify.theme.dark = true
  },
  data: () => ({
    drawer: null
  }),
  methods: {
    logout () {
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setUser', null)
      this.$router.push({
        name: 'root'
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue